﻿import { createFileRoute } from "@tanstack/react-router";
import { UsuariosFiliaisPage } from "@/paginas/pg_usuarios/usuarios-filiais";

export const Route = createFileRoute("/_authenticated/usuarios-filiais")({
  head: () => ({
    meta: [
      { title: "Filiais permitidas por usuário — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Defina quais filiais cada pessoa da equipe pode acessar; sem nenhuma marcada, o acesso vale para todas.",
      },
      { property: "og:title", content: "Filiais permitidas por usuário — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Controle de acesso às filiais para cada usuário do sistema.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: UsuariosFiliaisPage,
});
